import axios from "axios";
import { createClient } from "../util/axios-helpers";
import { endpoint } from "../util/http-helpers";

export interface PartnerInfo {
    id: string;
    name: string;
    domain: string | null;
    logo: string | null;
}

export interface ReservationLoginRequest {
    partnerDomain: string;
    reservationNumber: string;
    doorLockCode: string;
}

export interface UnitAddressDetails {
    street: string | null;
    city: string | null;
    state: string | null;
    zipCode: string | null;
    country: string | null;
}

export interface ReservationLoginResponse {
    token: string;
    expiresAt: string;
    guestName: string;
    guestEmail: string;
    unitName: string;
    unitPhotoUrl: string | null;
    unitAddress: string | null;
    checkIn: string;
    checkOut: string;
    partnerId: string;
    partnerName: string;
    partnerLogo: string | null;
    wifiNetworkName: string | null;
    wifiPassword: string | null;
    doorLockCode: string | null;
    unitAddressDetails: UnitAddressDetails | null;
    hasContactDetails: boolean;
    contactFirstName: string | null;
    contactLastName: string | null;
    contactEmail: string | null;
}

export interface ValidateSessionResponse {
    isValid: boolean;
    errorCode?: string | null;
    errorMessage?: string | null;
    unitName?: string | null;
    checkIn?: string | null;
    checkOut?: string | null;
}

export const getPartnerByDomain = (domain: string) => {
    const client = createClient(axios);
    return client.get<PartnerInfo>(endpoint(`api/v1/partners/by-domain/${domain}`));
};

export const reservationLogin = (request: ReservationLoginRequest) => {
    const client = createClient(axios);
    return client.post<ReservationLoginResponse>(endpoint('api/v1/auth/reservation-login'), request);
};

export const validateSession = () => {
    const client = createClient(axios);
    return client.post<ValidateSessionResponse>(endpoint('api/v1/auth/validate-session'));
};
